import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react';
import { Alert } from 'react-bootstrap';
import uniqueId from 'lodash.uniqueid';
import Heading from '../heading/Heading'; // Redux

import { errorDuck } from '../../ducks/error';
var errorOperations = errorDuck.operations;

var InlineError = function InlineError(props) {
  var _props$error = props.error,
      error = _props$error === void 0 ? {} : _props$error,
      _props$errorHandler = props.errorHandler,
      errorHandler = _props$errorHandler === void 0 ? function () {
    return "";
  } : _props$errorHandler,
      _props$store = props.store,
      store = _props$store === void 0 ? {
    dispatch: function dispatch() {
      return "";
    }
  } : _props$store,
      _props$category = props.category,
      category = _props$category === void 0 ? '' : _props$category;
  var dispatch = store.dispatch;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  useEffect(function () {
    // Show error if the type and category match
    if (error.display === 'inplace' && error.category === category) {
      setActive(true);
    }
  }, [props.error]);

  var handleClose = function handleClose() {
    dispatch(errorOperations.resetError());
    errorHandler();
    return setActive(false);
  };

  var variant = error.type || 'info';

  if (variant === 'error') {
    variant = 'danger'; // Use bootstrap's variant.
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Alert, {
    style: {
      zIndex: 9999
    },
    className: "cb-z-index-1",
    show: active,
    key: uniqueId(),
    variant: variant,
    dismissible: "true",
    onClose: handleClose
  }, error.title ? /*#__PURE__*/React.createElement(Heading, {
    level: "3",
    field: {
      value: error.title
    },
    className: "cb-type-title-2"
  }) : null, /*#__PURE__*/React.createElement("p", null, error.body)));
};

export default InlineError;